import React, { useMemo } from 'react';
import { BrandKitContext } from './brand-kit-context';
import type { BrandKit } from './types';

interface BrandKitProviderProps {
  brandKit?: BrandKit;
  children: React.ReactNode;
}

export const BrandKitProvider: React.FC<BrandKitProviderProps> = ({ brandKit, children }) => {
  const value = useMemo<BrandKit>(() => brandKit ?? {}, [brandKit]);
  return <BrandKitContext.Provider value={value}>{children}</BrandKitContext.Provider>;
};
